import React, { useCallback, useEffect, useState } from 'react';
import { useProductScanner, Product } from '../hooks/useProductScanner';
const NAMES = ['Giulia', 'Marco', 'Valentina', 'Davide', 'Chiara', 'Andrea', 'Lucia', 'Matteo', 'Sofia', 'Sebastiano', 'Paola', 'Nicola', 'Federica', 'Tommaso', 'Carolina'];
const CITIES = ['Milano', 'Roma', 'Torino', 'Napoli', 'Bologna', 'Firenze', 'Verona', 'Genova', 'Palermo', 'Bari', 'Padova', 'Catania'];
interface ToastData {
  name: string;
  city: string;
  timeAgo: number;
  product: Product;
}
export function RecentPurchaseToast() {
  const products = useProductScanner();
  const [isVisible, setIsVisible] = useState(false);
  const [toastData, setToastData] = useState<ToastData | null>(null);
  const getRandomItem = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
  const getRandomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
  const generateToastData = useCallback(() => {
    if (products.length === 0) return null;
    return {
      name: getRandomItem(NAMES),
      city: getRandomItem(CITIES),
      timeAgo: getRandomInt(1, 15),
      product: getRandomItem(products)
    };
  }, [products]);
  useEffect(() => {
    if (products.length === 0) return;
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const scheduleNextToast = (isFirst: boolean = false) => {
      const delay = isFirst ? getRandomInt(8000, 12000) : getRandomInt(15000, 25000);
      showTimeout = setTimeout(() => {
        const newData = generateToastData();
        if (newData) {
          setToastData(newData);
          setIsVisible(true);
          hideTimeout = setTimeout(() => {
            setIsVisible(false);
            scheduleNextToast(false);
          }, 5000);
        } else {
          scheduleNextToast(false);
        }
      }, delay);
    };
    scheduleNextToast(true);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [products, generateToastData]);
  if (!toastData) return null;
  return <div className={`fixed bottom-3 left-3 right-3 md:right-auto md:left-5 md:bottom-5 z-50 transition-[transform,opacity] duration-300 ease-out ${isVisible ? 'translate-y-0 opacity-100 pointer-events-auto' : 'translate-y-[120%] opacity-0 pointer-events-none'}`} data-id="element-256" data-mp="3mq41wmyr3djs">
      <div className="bg-[#150025]/95 backdrop-blur-sm border border-[rgba(194,0,111,0.3)] rounded-lg md:rounded-xl py-2 px-3 md:py-3 md:px-4 md:max-w-[320px] shadow-[0_8px_30px_rgba(0,0,0,0.5),0_0_20px_rgba(194,0,111,0.15)] relative overflow-hidden" data-id="element-257" data-mp="2z3p2l3sgipyu">
        <div className="flex items-center gap-2.5 md:gap-3" data-id="element-258" data-mp="3dra977ojj7bi">
          {/* Thumbnail */}
          <div className="shrink-0" data-id="element-259" data-mp="2gbwb5dt1dct8">
            <img src={toastData.product.thumbnailUrl} alt={toastData.product.title} className="w-8 h-8 md:w-10 md:h-10 rounded-md object-cover border border-white/10" data-id="element-260" data-mp="2gco4ehz5uygc" />
          </div>
          {/* Content — compact single flow */}
          <div className="flex-1 min-w-0" data-id="element-261" data-mp="ydqaal6ktgu2">
            <p className="text-white/80 text-[0.7rem] md:text-xs leading-tight truncate" data-id="element-262" data-mp="yf1ayc4q68gy">
              <span className="font-heading font-bold text-white" data-id="element-263" data-mp="tdlocfmwftwg">
                {toastData.name}
              </span>
              {' da '}
              {toastData.city}
              {' ha acquistato'}
            </p>
            <div className="flex items-center justify-between gap-2 mt-0.5" data-id="element-264" data-mp="jj3k99dklwc4">
              <span className="text-magenta-bright font-heading font-bold text-[0.75rem] md:text-sm truncate" data-id="element-265" data-mp="eopmj0bfrd4a">
                {toastData.product.title}
              </span>
              <span className="text-gold font-heading font-bold text-[0.75rem] md:text-sm shrink-0" data-id="element-266" data-mp="5qncjv9q5a4v">
                {toastData.product.priceText}
              </span>
            </div>
            <div className="flex items-center justify-between mt-0.5" data-id="element-267" data-mp="3rwak8z319hyt">
              <span className="text-green-400 text-[0.6rem] md:text-[0.7rem] font-medium flex items-center gap-0.5" data-id="element-268" data-mp="1vtnwh14x0i6q">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-269" data-mp="20sh8sq8gu35b">
                  <polyline points="20 6 9 17 4 12" data-id="element-270" data-mp="1i2j4ml7sgu6y"></polyline>
                </svg>
                Verificato
              </span>
              <span className="text-white/30 text-[0.6rem] md:text-[0.65rem]" data-id="element-271" data-mp="136jm0gn1zbnk">
                {toastData.timeAgo} min fa
              </span>
            </div>
          </div>
          {/* Close button */}
          <button type="button" onClick={e => {
          e.stopPropagation();
          setIsVisible(false);
        }} className="shrink-0 text-white/30 hover:text-white/60 transition-colors duration-150 ease-out p-0.5" aria-label="Chiudi" data-id="element-272" data-mp="2xjjc53p27o93">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-273" data-mp="ltl7hvxxr0lr">
              <line x1="18" y1="6" x2="6" y2="18" data-id="element-274" data-mp="15ivkv3a7l9gp"></line>
              <line x1="6" y1="6" x2="18" y2="18" data-id="element-275" data-mp="1jjetocmi0jjx"></line>
            </svg>
          </button>
        </div>
      </div>
    </div>;
}